export default "__VITE_ASSET__2UERvFV___"